

import { useEffect, useRef } from "react";

const TravelWidget = () => {
  const widgetRef = useRef(null);

  useEffect(() => {
    if (!widgetRef.current) return;

    const scriptId = "travel-widget-script";

    // Avoid adding the script multiple times
    if (document.getElementById(scriptId)) return;

    const script = document.createElement("script");
    script.id = scriptId;
    script.src = "//www.travelpayouts.com/widgets/97b99d9fd2e466cb3fd63f9f3c256bf8.js?v=2012";
    script.charset = "utf-8";
    script.async = true;

    widgetRef.current.appendChild(script);

    return () => {
      // Use optional chaining to prevent errors
      document.getElementById(scriptId)?.remove();
    };
  }, []);

  return <div ref={widgetRef} id="travel-widget-container"></div>;
};

export default TravelWidget;
